<div class="container">
  <div class="card"  *ngFor="let product of products">
    <img [src]="'https://angvm01.uksouth.cloudapp.azure.com:5527/Images/' + product.imagePath">
    <div class="card__head">{{product.imageName}}</div>
  </div>
</div>
